"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingCardsMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class MarketingCardsMapper {
    toDomain(result) {
        const isMarketingCardLoading = lodash_1.default.get(result, "loading");
        const marketingCards = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.holding.marketingCards");
        return {
            isMarketingCardLoading,
            marketingCards,
        };
    }
}
exports.MarketingCardsMapper = MarketingCardsMapper;
